import { View } from "binder"
import { CreatePaginationInfoViewModel } from "./createPaginationInfo-viewModel"

export class CreatePaginationInfoView extends View<CreatePaginationInfoViewModel>{
    GetViewUniqueId(): string {
        return "V-CAC4A6B4-9FBB-4958-9029-AF4DA80B25F6"
    }
    loadHtml(): string {
        let element = require('./createPaginationInfo.html').default;
        let style = require('./createPaginationInfo.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isStatic(v: boolean) { this._isStatic = v; } public get isStatic(): boolean { return this._isStatic;} private _isStatic: boolean;
    public set currentPage(v: any) { this._currentPage = v; } public get currentPage(): any { return this._currentPage;} private _currentPage: any;
    public set totalPages(v: any) { this._totalPages = v; } public get totalPages(): any { return this._totalPages;} private _totalPages: any;
    public set resultName(v: string) { this._resultName = v; } public get resultName(): string { return this._resultName;} private _resultName: string;
    
}
